// Pure timeframe filtering for the notifications screen. Extracted so it can be
// unit-tested without React. `now` is injectable for deterministic tests.

import type { NotificationItem, NotificationTimeframe } from "./model.js";

/** Epoch-ms cutoff for a timeframe, or null for "all" (no lower bound). */
export function timeframeCutoff(
  timeframe: NotificationTimeframe,
  now: Date = new Date(),
): number | null {
  if (timeframe === "all") return null;
  const ref = new Date(now.getTime());
  if (timeframe === "today") {
    ref.setHours(0, 0, 0, 0);
    return ref.getTime();
  }
  if (timeframe === "week") {
    ref.setDate(ref.getDate() - 7);
    return ref.getTime();
  }
  // month
  ref.setMonth(ref.getMonth() - 1);
  return ref.getTime();
}

/** Keep only items created at/after the timeframe cutoff. */
export function filterByTimeframe(
  items: NotificationItem[],
  timeframe: NotificationTimeframe,
  now: Date = new Date(),
): NotificationItem[] {
  const cutoff = timeframeCutoff(timeframe, now);
  if (cutoff === null) return items;
  return items.filter((n) => new Date(n.createdAt).getTime() >= cutoff);
}
